// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background-color: var(--primary);
  color: var(--text-primary);
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: color 0.2s ease;
}

#internalShareIssuePage_form__D-0GF {
  display: flex;
  justify-content: center;
  grid-template-rows: 1fr 1fr;
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/internal/styles/internalShareIssuePage.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;AACF","sourcesContent":["button {\n  background-color: var(--primary);\n  color: var(--text-primary);\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  transition: color 0.2s ease;\n}\n\n#form {\n  display: flex;\n  justify-content: center;\n  grid-template-rows: 1fr 1fr;\n  margin-bottom: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `internalShareIssuePage_form__D-0GF`
};
export default ___CSS_LOADER_EXPORT___;
